import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(
		private messageService: MessageService
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		let authReq = request;
		const token = sessionStorage.getItem('token');

		console.log('Auth Interceptor chamado!');
		// console.log("Token: " + token);

		if (token != null) {
			authReq = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
				},
			});
		}

		return next.handle(authReq).pipe(
			catchError((err) => {
				if ([403].includes(err.status)) {
					window.location.href = '/login';
				}

				const error =
					(err && err.error && err.message) || err.statusText;

				console.log('Erro intercpetor: ' + error);
				console.log('Erro status: ' + err.status);

				if (err.status === 404) {
					this.messageService.add({
						severity: 'warn',
						summary: 'Atenção',
						detail: 'registro não encontrado',
						life: 3000,
					});
				} else if (err.status === 500) {
					this.messageService.add({
						severity: 'err',
						summary: 'Erro',
						detail: err.message,
						life: 3000,
					});
				}

				return throwError(() => error);
			})
		);
	}
}

export const httpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
